import Command from './command';
import ContactCreateModal from '@/views/contacts/components/ContactCreateModal';

class CreateContact extends Command {
  id = 'createContact';
  icon = 'campaigns/person';
  title = 'Create Contact';
  permission = 'add_contacts';
  actions = ContactCreateModal;

  run() {
    const modal = this.vm.$refs[this.id]?.[0];
    if (modal) {
      modal.open();
    }
    return false;
  }
}

export default CreateContact;
